module.exports = "<div class=\"loader\">Loading...</div>\r\n\r\n"